import { useState } from 'react'
import WorkflowSidebar from '../../../components/admin/workflow/WorkflowSidebar'
import FinanceDashboardHeader from '../../../components/finance/dashboard/FinanceDashboardHeader'
import BanksInfoDisplay from '../../../components/finance/dashboard/BanksInfoDisplay'
import CustodianInfoDisplay from '../../../components/finance/dashboard/CustodianInfoDisplay'
import '../../../pages/admin/dashboard/DashboardPage.css'

const FinanceDashboardPage = () => {
  const [selectedStep, setSelectedStep] = useState(1)
  const [activeFinanceTab, setActiveFinanceTab] = useState<'banks' | 'custodian'>('custodian')

  const workflowSteps = [
    {
      number: 1,
      title: 'Financial Data',
      subtitle: 'View banks & custodian info',
      active: selectedStep === 1
    }
  ]

  const handleStepSelect = (step: number) => {
    setSelectedStep(step)

    // Reset to first tab when switching steps
    if (step === 1) {
      setActiveFinanceTab('custodian')
    }
  }

  const renderMainContent = () => {
    switch (selectedStep) {
      case 1:
        return (
          <div className="data-sources-section" key={`finance-data-${selectedStep}`}>
            {/* Horizontal Tab Navigation */}
            <div className="horizontal-tabs-container">
              <div className="horizontal-tabs-wrapper">
              <button
                  onClick={() => setActiveFinanceTab('custodian')}
                  className={`horizontal-tab-button ${activeFinanceTab === 'custodian' ? 'active' : ''}`}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <rect x="3" y="11" width="18" height="10" rx="2" ry="2"/>
                    <circle cx="12" cy="16" r="1"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  Custodian Info
                </button>

                <button
                  onClick={() => setActiveFinanceTab('banks')}
                  className={`horizontal-tab-button ${activeFinanceTab === 'banks' ? 'active' : ''}`}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"/>
                    <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01"/>
                  </svg>
                  Banks Info
                </button>
              </div>
            </div>

            {/* Tab Content */}
            <div className="horizontal-tab-content">
              {activeFinanceTab === 'banks' ? (
                <BanksInfoDisplay />
              ) : (
                <CustodianInfoDisplay />
              )}
            </div>
          </div>
        )
      default:
        return (
          <div style={{ padding: '40px', textAlign: 'center', color: '#6B7280' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
              Finance Dashboard
            </h3>
            <p style={{ fontSize: '14px' }}>
              Select a workflow step to get started
            </p>
          </div>
        )
    }
  }

  return (
    <div className="fixed inset-0 bg-gray-100 overflow-auto z-50">
      {/* Header */}
      <FinanceDashboardHeader />

      {/* Main Content */}
      <div className="flex">
        {/* Sidebar - Finance Workflow */}
        <WorkflowSidebar
          workflowSteps={workflowSteps}
          onStepSelect={handleStepSelect}
        />

        {/* Main Content Area - Full Width */}
        <div className="flex-1 bg-gray-100">
          {renderMainContent()}
        </div>
      </div>
    </div>
  )
}

export default FinanceDashboardPage